// tslint:disable-next-line: import-name
import Highlighter from 'react-highlight-words';
import React, { CSSProperties } from 'react';
import { Icon } from '../commonModels';
import { JustifyContent, FlexBox } from '../../utils/css-classes';

const boldStyle: CSSProperties = {
  fontWeight: 'bold',
};

const clickableStyle: CSSProperties = {
  textDecoration: 'none',
  color: 'inherit',
  cursor: 'pointer',
};

interface Props {
  title: string;
  topRightLabelText?: string;
  onClick?: () => void;
  iconClassName: Icon;
  paddingClass?: string;
  bottomRightIconClassName?: string;
  highlight?: string;
}

// tslint:disable-next-line:function-name
export default function TileComponent({
  title,
  topRightLabelText,
  onClick,
  iconClassName,
  paddingClass,
  bottomRightIconClassName,
  highlight,
}: Props) {
  const tile = (
    <div className={`mx-4 ${paddingClass || 'py-4'} text-center shipments-tile`}>
      <div className={`${FlexBox.FLEX} ${JustifyContent.CENTER}`}>
        {/*The element below is invisible in order to center the icon*/}
        {topRightLabelText && <small className="invisible" style={boldStyle}>{topRightLabelText}</small>}
        {bottomRightIconClassName && <i className={`invisible fas ${bottomRightIconClassName}`}></i>}
        <span className={`m-2 ${iconClassName}`} />
        {topRightLabelText && <small className="" style={boldStyle}>{topRightLabelText}</small>}
        {bottomRightIconClassName && <i className={`fas ${bottomRightIconClassName}`}></i>}
      </div>
      <small style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
        <Highlighter
          highlightClassName="highlight"
          searchWords={highlight ? [highlight] : []}
          autoEscape={true}
          textToHighlight={title}
        />
      </small>
    </div>
  );

  return onClick ?
    (
      <a
        style={clickableStyle}
        title={title}
        onClick={() => onClick()}
      >
        {tile}
      </a>
    ) :
    tile;
}
